__turbopack_context__.v({
  "detail": "PatientDetail-module__93Fkia__detail",
  "detailAge": "PatientDetail-module__93Fkia__detailAge",
  "detailNotes": "PatientDetail-module__93Fkia__detailNotes",
});
